import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const GridFormSwitcher = props => {
	const { match, renderGrid, RenderNew, RenderCopy, RenderEdit } = props;
	const propsData = props;
	const { path } = match;
	return (
		<Switch>
			<Route exact path={`${path}/`} component={renderGrid} />
			<Route exact path={`${path}/new`} render={() => <RenderNew {...propsData} type="new" />} />
			<Route exact path={`${path}/new/:view`} render={() => <RenderNew {...propsData} type="new" />} />
			<Route exact path={`${path}/copy/:id/:view`} render={() => <RenderCopy {...propsData} type="copy" />} />
			<Route exact path={`${path}/copy/:id`} render={() => <RenderCopy {...propsData} type="copy" />} />
			<Route exact path={`${path}/:id`} render={() => <RenderEdit {...propsData} type="update" />} />
			<Route exact path={`${path}/:id/:view`} render={() => <RenderEdit {...propsData} type="update" />} />
		</Switch>
	);
};

GridFormSwitcher.propTypes = {
	match: PropTypes.object,
	RenderCopy: PropTypes.any,
	RenderEdit: PropTypes.any,
	RenderNew: PropTypes.any,
	renderGrid: PropTypes.any,
	prefix: PropTypes.string,
	createItem: PropTypes.func,
	updateItem: PropTypes.func,
	copyItem: PropTypes.func,
	items: PropTypes.any,
};

export default withRouter(GridFormSwitcher);
